export type FontStatus = 'loaded' | 'timeout' | 'unsupported' | 'error';

/**
 * 픽셀 한글 폰트를 기다린다. 실패해도 게임은 시작한다 — 다만 fontStatus 를 계측에 남겨
 * 시스템 폰트로 판을 돈 표본을 사후에 분리할 수 있게 한다.
 */
export async function loadGameFont(family: string, timeoutMs: number): Promise<FontStatus> {
  const fonts = (document as Document & { fonts?: FontFaceSet }).fonts;
  if (fonts === undefined) return 'unsupported';
  const timer = new Promise<'timeout'>((resolve) => {
    window.setTimeout(() => resolve('timeout'), timeoutMs);
  });
  try {
    const load = fonts.load(`16px "${family}"`).then(() => 'loaded' as const);
    return await Promise.race([load, timer]);
  } catch {
    return 'error';
  }
}
